import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { AssistanceRequest } from '../models/AssistanceRequest';
import { AllowedCursusResponse } from '../models/AllowedCursusResponse';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient, @Inject(DOCUMENT) private document: Document) { }

  getDetails() {
    return this.http.get(`${environment.apiUrl}/student/details`, { responseType: 'json', withCredentials: true });
  }

  login() {
    this.document.location.href = `${environment.casUrl}/cas/login?service=${environment.casService}%2Flogin%2Fcas`;
  }

  checkIfStudentHasAllowedCursus(): Observable<AllowedCursusResponse> {
    return this.http.get<AllowedCursusResponse>(`${environment.apiUrl}/student/hasAllowedCursus`, { responseType: 'json', withCredentials: true });
  }

  checkAuthentication(): Observable<boolean> {
    // Call the backend to check if the user is authenticated.
    return this.http.get(environment.apiUrl + '/auth/check', { withCredentials: true }).pipe(
      map(response => {
        // If backend returns OK, user is authenticated.
        return true;
      }),
      catchError(error => {
        // If not authenticated, redirect to login.
        this.login();
        return of(false);
      })
    );
  }

  getLibWebVet(codAnu: string, codEtp: string, codVrsVet: string) {
    return this.http.post(`${environment.apiUrl}/apogee/lib-web-vet`, 
      {
        "codAnu": codAnu,
        "codDip": "aucun",
        "codVrsVdi": "aucun",
        "codEtp": codEtp,
        "codVrsVet": codVrsVet,
        "codElp": "aucun"
    },
    { responseType: 'json', withCredentials: true }).pipe(
      map((response: any) => response as { libWebVet: string })); 
  }

  sendAssistanceRequest(request: AssistanceRequest): Observable<any> {
    return this.http.post<string>(`${environment.apiUrl}/conversation/start-conversation`, request, { withCredentials: true });
  }
}